import React, { useEffect } from "react";
import { type OngoingCallView } from '../../models/mappers/ongoingCall';
import { formatUSPhoneNumber } from "../../utils/phoneNumberFormatting";

type OngoingCallsAccordionRowProps = {
  data: OngoingCallView;
};

export const OngoingCallsAccordionRow: React.ComponentType<OngoingCallsAccordionRowProps> = ({
  data
}) => {

  return (
    <>
      {data &&
        <div className="ongoing-calls-accordion py-3 px-4 border-top">
          <div style={{ marginLeft: "40px" }}>

            <div className="row">
              <div className="col-xl-6 col-xs-12">
                <sup className="text-muted">Call-SId: {data.callSid ?? "-"}</sup>
              </div>
              <div className="col-xl-6 col-xs-12">
                <sup className="text-muted">Call-Id: {data.callId ?? "-"}</sup>
              </div>
            </div>

            <div className="row">
              <div className="mb-2 col-xl-6 col-xs-12">
                <div className="d-flex flex-column">
                  <div>
                    <h6 style={{ marginBottom: "4px", fontSize: "15px" }}>Operators in call</h6>
                    {data.operators && data.operators?.length > 0 ? (
                      <ul style={{ marginLeft: '1rem', listStyle: 'disc' }}>
                        {data.operators?.map((operator) => (
                          <li key={operator.operatorId} className="">
                            <span className="pr-4">{operator.operatorName ?? "_"}</span>
                            <span>{operator.operatorId}</span>
                          </li>
                        ))}
                      </ul>
                    ) :
                      (
                        <span>No operators</span>
                      )
                    }
                  </div>
                  <div className="mt-4 mb-4">
                    <h6 style={{ marginBottom: "4px", fontSize: "15px" }}>Outbound Calls (Added Participants)</h6>
                    {data.outboundPhoneNumbers && data.outboundPhoneNumbers?.length > 0 ? (
                      <>
                        {data.outboundPhoneNumbers?.map((participant) => (
                          <div key={participant}>
                            {formatUSPhoneNumber(participant)}
                          </div>
                        ))}
                      </>
                    ) :
                      (
                        <span>No participants</span>
                      )
                    }
                  </div>
                </div>
              </div>

              <div className="col-6">
                <h6 style={{ marginBottom: "4px", fontSize: "15px" }}>Custom Input Fields</h6>
                {data.customInputFields && data.customInputFields?.length > 0 ? (
                  <div className="table-responsive">
                    <table className="table table-sm ongoing-calls-accordion__table">
                      <thead>
                        <tr>
                          <th scope="col">Type</th>
                          <th scope="col">Name</th>
                          <th scope="col">Value</th>
                          <th scope="col">Enabled</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data.customInputFields?.map((field) => (

                          <tr key={field.name}>
                            <th scope="row">{field.criteriaType ?? "_"}</th>
                            <td className="overflow-clip-ellipsis mr-2 ongoing-calls-accordion__text" style={{ maxWidth: "200px" }}>{field.name ?? "_"}</td>
                            <td className="mr-2 ongoing-calls-accordion__text">{field.value ?? "_"}</td>
                            <td className="ongoing-calls-accordion__text" style={{ maxWidth: "200px" }}>{(field.isEnabled || field.isEnabled == null) ? "Yes" : "No"}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                ) :
                  (
                    <p>No data</p>
                  )
                }

              </div>
            </div>
          </div>
        </div>
      }
    </>
  );
};
